import { render } from "./NewsListCard.vue?vue&type=template&id=b26e317c&scoped=true"
import script from "./NewsListCard.vue?vue&type=script&lang=js"
export * from "./NewsListCard.vue?vue&type=script&lang=js"

import "./NewsListCard.vue?vue&type=style&index=0&id=b26e317c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b26e317c"]])

export default __exports__